import PropTypes from 'prop-types';
import React from 'react';

const FullScreenDialog = React.forwardRef(({ children, extraClass }, ref) => (
    <div className={`full-screen-dialog ${extraClass}`} ref={ref}>
        {children}
    </div>
));

FullScreenDialog.displayName = 'FullScreenDialog';

FullScreenDialog.defaultProps = {
    extraClass: ''
};

FullScreenDialog.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    extraClass: PropTypes.string
};

export default FullScreenDialog;
